<template>
    <div class="audit">
        <div class="back" @click="closeThird">
            <i class="el-icon-arrow-left"></i>
            Back
        </div>
        <div class="title">Manual review application for net 60 terms</div>
        <div class="desc">No problem, just fill out your information and we’ll take care of the rest</div>
        <div class="inp">
            <div class="inp-title">
                Business Name *
            </div>
             <el-input v-model="businessName" placeholder="Enter business Name"></el-input>
        </div>
        <div class="inp-list">
            <div class="inp col-wid">
                <div class="inp-title">
                    EIN*
                </div>
                <el-input v-model="ein" placeholder="Enter EIN"></el-input>
            </div>
            <div class="inp col-wid">
                <div class="inp-title">
                    D&B Number
                </div>
                <el-input v-model="dbNumber" placeholder="Enter D&B Number"></el-input>
            </div>
        </div>
        <div class="inp">
            <div class="inp-title">
                Business Address*
            </div>
             <el-input v-model="businessAddress" placeholder="Enter Business Address"></el-input>
        </div>
        <div class="inp">
            <div class="inp-title">
                City*
            </div>
             <el-input v-model="city" placeholder="Enter City"></el-input>
        </div>
        <div class="inp">
          <div class="inp-title">
                  State*
          </div>
          <el-input v-model="state" placeholder="Enter State"></el-input>
        </div>
        <div class="inp-list">
            <div class="inp col-wid">
                <div class="inp-title">
                    Country*
                </div>
                <el-input v-model="country" placeholder="Enter Country" disabled></el-input>
            </div>
            <div class="inp col-wid">
                <div class="inp-title">
                    Zipcode*
                </div>
                <el-input v-model="zipCode" placeholder="Enter Zipcode"></el-input>
            </div>
        </div>
        <!-- <div class="inp">
            <div class="inp-title">
                Optional
            </div>
             <div class="desc">Add supporting documents such as financial statements or trade references
Click or drop files here</div>
        </div> -->
        <div class="btns">
            <div class="btn" @click="sureMenualAudi" v-loading="loading">Finish</div>
        </div>
    </div>
</template>
<script>
import {menualAudit} from '@/api/creditPayment.js'
import {getCreditLimit} from '@/api/manage.js'
export default {
  data() {
    return {
      loading: false,
      ein: '', // 976746645
      businessName: '', // 公司名称
      businessAddress: '', //
      state: '', // "CN",(国家编码)
      zipCode: '', // :"100000",
      dbNumber: '', // 8503945735
      city: '',
      country: 'United States of America'
    }
  },
  methods: {
    // 返回
    // backFirst(){
    //     console.log("sub")
    //     this.$emit('backFirst','first')
    // },
    closeThird() {
      console.log('关闭3')
      this.$emit('closeThird', 'second')
    },
    getCreditLimit() {
      getCreditLimit('/balance/creditLimit').then(res => {
        console.log(res, '余额信息')
        if (res.code == 200) {
          this.limit = res.result
          console.log(this.limit, '限制信息')
        }
      })
    },
    // 人工审核提交表单
    sureMenualAudi() {
      let data = {
        ein: this.ein,
        businessName: this.businessName,
        businessAddress: this.businessAddress,
        state: this.state,
        zipCode: this.zipCode,
        dbNumber: this.dbNumber,
        city: this.city,
        country: this.country
      }
      if (!this.ein) {
        this.$message({
          message: 'Please enter the EIN',
          type: 'warning'
        })
        return
      }
      if (!this.businessName) {
        this.$message({
          message: 'Please enter business Name',
          type: 'warning'
        })
        return
      }
      if (!this.businessAddress) {
        this.$message({
          message: 'Please Enter Business Address',
          type: 'warning'
        })
        return
      }
      if (!this.state) {
        this.$message({
          message: 'Please Enter State',
          type: 'warning'
        })
        return
      }
      if (!this.zipCode) {
        this.$message({
          message: 'Please Enter zipCode',
          type: 'warning'
        })
        return
      }
      // if (!this.dbNumber) {
      //   this.$message({
      //     message: 'Please Enter D&B Number',
      //     type: 'warning'
      //   })
      //   return
      // }
      if (!this.city) {
        this.$message({
          message: 'Please Enter City',
          type: 'warning'
        })
        return
      }
      this.loading = true
      menualAudit('/balance/apply/net-Term', data).then(res => {
        if (res.code == 200 && res.success) {
          this.loading = false
          this.$message.success(res.message)
          // 请求后，当请求没有异常的情况下，将返回的申请状态的值返回给父组件，将当前的dialog隐藏掉。并且要打开状态的那个框
          this.$emit('backFirst', res.result.status, data.businessName)
        } else {
          this.$message({
            message: res.message,
            type: 'warning'
          })
          this.loading = false
        }
      })
    }

  }
}
</script>
<style lang="less" scoped>
.audit{
    position: fixed;
    padding: 30px;
    width: 600px;
    left: 50%;
    top: 130px;
    margin-left: -300px;
    z-index: 100;
    background: #FFFFFF;
    border: 1px solid #E1E1E1;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.05);
    .back{
        display: flex;
        align-items: center;
        font-size: 18px;
        cursor: pointer;
    }
    .title{
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #262B2F;
        margin: 15px 0;
    }
    .desc{
        font-size: 14px;
        font-family: Graphik;
        font-weight: 500;
        color: #262B2F;
    }
    .inp-list{
        display: flex;
        justify-content: space-between;
        .col-wid{
            flex: 1;
            &:last-child{
                margin-left: 10px;
            }
        }
    }
    .inp{
        display: flex;
        flex-direction: column;
        .inp-title{
            font-size: 14px;
            font-family: Graphik;
            font-weight: 500;
            color: #262B2F;
            padding: 10px 0;
        }

        .desc{
            background: #FFFFFF;
            border: 1px dotted #8F8F8F;
            opacity: 1;
            padding: 25px 10px;
        }
    }
    .btns{
        display: flex;
        justify-content: center;
        margin-top: 30px;
        .btn{
            display: flex;
            justify-content: center;
            align-items: center;
            background: #262B2F;
            width: 50%;
            height: 50px;
            border-radius: 5px;
            font-size: 14px;
            font-family: Graphik;
            font-weight: normal;
            color: #FFFFFF;
            cursor: pointer;
        }
    }
}
@media screen and (max-width: 420px) {
    .audit{
        margin: 0;
        width: calc(100vw - 80px);
        left: 10px;
        top: 30px;
        max-height: 600px;
        overflow-y: auto;
    }
    .inp-list{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
         .col-wid{
            flex: 1;
            &:last-child{
                margin-left:0 !important
            }
        }
    }
    .inp{
        display: flex;
        flex-direction: column;
        .inp-title{
            font-size: 14px;
            font-family: Graphik;
            font-weight: 500;
            color: #262B2F;
            padding: 10px 0;
        }
        .desc{
            padding: 0;
            padding: 10px 10px !important;
        }
    }

}
@media screen and (max-width: 380px) {
  .audit{max-height: 450px !important;}
}
</style>



// WEBPACK FOOTER //
// src/pages/credit-payment/auditDialog.vue